import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { InfoBlock } from 'components/Shared/InfoBlock';
import { StepViewer } from 'components/Shared/StepViewer';
import { Spin } from 'components/UI/Spin';
import { useHistory } from 'hooks/generic/useHistory';
import { isMobile } from 'utils';
import { EAccountRouteKeys } from 'constants/account/account-route-keys';

type InfoBlockLoggedInProps = {
  className?: string;
  loading?: boolean;
};

export const InfoBlockLoggedIn: FC<InfoBlockLoggedInProps> = ({
  className,
  loading
}) => {
  const { t } = useTranslation();
  const { push } = useHistory();

  const handleOpenAccount = () => {
    push(EAccountRouteKeys.ACCOUNT_PROFILE_INFO);
  };

  return (
    <StepViewer
      header={{ show: false }}
      hideFooter
      withoutWrapper={isMobile()}
      steps={[
        {
          title: {
            text: t('account.alreadyLoggedInInfoBlockTitle')
          },
          render: () => (
            <>
              {loading && <Spin type="absolute" withBackground />}
              <InfoBlock
                className={className}
                title={t('account.alreadyLoggedInInfoBlockTitle')}
                type="plain"
                imageType="user"
                size="small"
                buttonProps={{
                  onClick: handleOpenAccount,
                  text: t('account.alreadyLoggedInInfoBlockButtonText')
                }}
              />
            </>
          )
        }
      ]}
    />
  );
};
